import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLang } from "@/lib/LangContext";

function Row({ item, i, open, onToggle }) {
  return (
    <div className="border-t border-white/10" data-testid={`faq-item-${i}`}>
      <button
        onClick={onToggle}
        className="w-full text-left py-8 lg:py-10 flex items-start gap-6 group"
        aria-expanded={open}
      >
        <span className="font-mono-ef text-[10px] uppercase tracking-[0.24em] text-white/40 pt-3 shrink-0 w-8">
          {String(i + 1).padStart(2, "0")}
        </span>
        <span className="flex-1 font-display text-2xl lg:text-3xl font-bold tracking-tight text-white group-hover:text-red-400 transition-colors">
          {item.q}
        </span>
        <span className={`shrink-0 mt-2 transition-transform duration-500 ${open ? "rotate-45" : ""}`}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
          </svg>
        </span>
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            key="content"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.5, ease: [0.19, 1, 0.22, 1] }}
            className="overflow-hidden"
          >
            <div className="pl-14 pb-10 pr-10 text-base lg:text-lg text-white/65 leading-relaxed max-w-3xl">
              {item.a}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default function FAQ() {
  const { t } = useLang();
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="relative py-28 lg:py-40" data-testid="faq-section">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-8">
          <div className="lg:col-span-8">
            <div className="text-[11px] uppercase tracking-[0.28em] text-red-400 font-mono-ef">
              — {t.faq.overline}
            </div>
            <h2 className="mt-6 font-display font-black text-5xl sm:text-6xl lg:text-7xl leading-[0.9] tracking-[-0.035em]">
              {t.faq.title}
            </h2>
          </div>
        </div>

        <div className="mt-10 border-b border-white/10">
          {t.faq.items.map((it, i) => (
            <Row
              key={it.q}
              item={it}
              i={i}
              open={open === i}
              onToggle={() => setOpen(open === i ? -1 : i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
